<template>
    <v-container container--fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="change-password-wrapper">
                <h1 class="headline">Change Password</h1>
                <v-alert class="pa-2 mb-2 mt-2" :value="firstLogin" outlined color="#3ab0ce" icon="info" transition="scale-transition">
                  <span class="first-login-info">For increased security, please change your password after first login and every 90 days.</span>
                </v-alert>
                <v-form>
                    <v-text-field
                            id="old_password"
                            name="old_password"
                            label="Current Password*"
                            v-model="old_password"
                            :append-icon="e1 ? 'visibility' : 'visibility_off'"
                            @click:append="e1 = !e1"
                            :type="e1 ? 'password' : 'text'"
                            placeholder="Please Enter"
                            :error-messages="errors($v.old_password) || server_errors.old_password"
                            @blur="$v.old_password.$touch()"
                            @focus="resetServerValidation">
                    </v-text-field>
                    <v-text-field
                            id="new_password"
                            class="mt-2"
                            name="new_password"
                            label="New Password*"
                            v-model="new_password"
                            :append-icon="e2 ? 'visibility' : 'visibility_off'"
                            @click:append="e2 = !e2"
                            :type="e2 ? 'password' : 'text'"
                            placeholder="Please Enter"
                            :error-messages="errors($v.new_password) || server_errors.password"
                            @blur="$v.new_password.$touch()"
                            @focus="resetServerValidation">
                    </v-text-field>
                    <v-text-field
                            id="confirm_new_password"
                            class="mt-2"
                            name="confirm_new_password"
                            label="Confirm New Password*"
                            v-model="confirm_new_password"
                            :append-icon="e3 ? 'visibility' : 'visibility_off'"
                            @click:append="e3 = !e3"
                            :type="e3 ? 'password' : 'text'"
                            placeholder="Please Enter"
                            :error-messages="errors($v.confirm_new_password)"
                            @blur="$v.confirm_new_password.$touch()"
                            @focus="resetServerValidation">
                    </v-text-field>
                    <v-alert class="pa-2 mt-4" :value="$v.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">Please fill out all required fields correctly</span>
                    </v-alert>
                    <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                    <v-btn
                      id="btnChangePassword"
                      width="100%"
                      color="primary"
                      block
                      :loading="loading"
                      :disabled="loading"
                      @click="changePassword" 
                    >
                      Submit
                    </v-btn>
                    <div v-if="firstLogin" class="text-center mt-4">
                      <span @click="skip" class="skip">Skip</span>
                    </div>
                </v-form>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
  import ApiService from "@/common/api.service"
  import { validationMixin } from 'vuelidate'
  import { required, minLength, helpers, sameAs, not } from 'vuelidate/lib/validators'
  import { valMessages, getValMessage } from '@/common/error-messages'
  import { mapGetters, mapActions } from "vuex"
  import {SKIP_CHANGE_PASSWORD} from "@/store/mutations.type"

  const validations = {
    old_password: { required },
    new_password: { required, txtMinLen: minLength(8), diferentFromOldPassword: not(sameAs('old_password')) },
    confirm_new_password: { required, txtMinLen: minLength(8), sameAsPassword: sameAs('new_password') }
  }
  export default {
    name: 'ChangePassword',
    mixins: [validationMixin],
    validations,
    data: () => ({
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      errorShow: false,
      loading: false,
      e1: true,
      e2: true,
      e3: true,

      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...',
      server_errors: {}
    }),
    methods: {
      ...mapActions(['vEmit']),
      changePassword() {
        this.resetServerValidation()
        this.$v.$touch()
        if(!this.$v.$invalid) {
          this.loading = true
          let data = {
            old_password: this.old_password,
            password: this.new_password,
            password_confirmation: this.confirm_new_password
          }

          console.log(data)
          ApiService.post('/change_password', data)
            .then(resposne => {
              this.loading = false
              this.old_password = '',
              this.new_password = '',
              this.confirm_new_password = '',
              this.$v.$reset()
              this.vEmit({ 
                name: "notification", 
                data: {
                  status: 'success', 
                  text: 'Your Password has been successfully changed.'
                }
              })
              if (this.firstLogin) { this.skip() }
            })
            .catch(({ response }) => {
                this.loading = false
                this.serverValidation = false
                if (response.data.error) {
                  this.serverValidationMessage = this.titleCase(response.data.error)
                }
                if(response.data.message){
                  this.serverValidationMessage = response.data.message
                }
                if (response.data.errors) {
                  if (typeof response.data.errors === 'string') {
                    this.serverValidationMessage = response.data.errors
                  } else {
                    this.server_errors = response.data.errors
                  }
                }
            })
        }
      },
      skip() {
        this.$store.commit(SKIP_CHANGE_PASSWORD)
        this.$router.push({name: "dashboard"})
      },
      titleCase(str){
          return _.startCase(str.replace(/_/g, ' '));
      },
      resetServerValidation() {
        this.serverValidation = true
        this.serverValidationMessage = 'Oops something went wrong...'
        this.server_errors = {}
      },
      errors: getValMessage(valMessages)(validations)
    },
    computed: {
      ...mapGetters(["firstLogin"]),
    }
  }
</script>

<style scoped>
    .change-password-wrapper h1 {
        text-align: center;
        padding-bottom: 20px;
    }

    .change-password-wrapper {
        width: 100%;
        max-width: 320px;
    }

    .change-password-wrapper .first-login-info {
        line-height: 1.3;
        font-size: 13px;
        color: black;
    }

    .change-password-wrapper .skip {
      font-size: 14px; 
      color: #00838F; 
      text-decoration: underline; 
      cursor: pointer;
    }

    .btn__content {
        padding-top: 2px;
        height: fit-content;
    }
</style>
